// import { ReactNode } from "react";
// import EcommerenceProducts from "src/pages/Ecommerence/EcommerenceProducts";
// import { Navigate } from "react-router-dom";
// import DashboardSaas from "../pages/Dashboard-saas";
// import DashboardCrypto from "../pages/Dashboard-crypto";
// import DashboardBlog from "../pages/Dashboard-blog";
// import DashboardJob from "../pages/Dashboard-job";

// File Manager
import FileManager from "../pages/FileManager/index";

//Ecommerce
// import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index";
import EcommerenceProducts from "../pages/Ecommerce/EcommerceProduct";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProductDetail";

// //Tasks
import TasksList from "../pages/Tasks/tasks-list";
import TasksKanban from "../pages/Tasks/tasks-kanban";
import TasksCreate from "../pages/Tasks/tasks-create";

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list";
import InvoiceDetail from "../pages/Invoices/invoices-detail";

// //Projects
import ProjectsGrid from "../pages/Projects/projects-grid";
import ProjectsList from "../pages/Projects/projects-list";
import ProjectsCreate from "../pages/Projects/projects-create";
import ProjectsOverview from "../pages/Projects/ProjectOverview/projects-overview";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

//Chat
import Chat from "../pages/Chat/Chat";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplate from "../pages/Email/email-basic-template";
import EmailAlertTemplate from "../pages/Email/email-template-alert";
import EmailTemplateBilling from "../pages/Email/email-template-billing";

//Contact Page
import ContactsGrid from "../pages/Contacts/contacts-grid";
import ContactsList from "../pages/Contacts/ContactList/contacts-list";
import ContactsProfile from "../pages/Contacts/ContactProfile/contacts-profile";

//Blog
import BlogList from "../pages/Blog/BlogList/index";
import BlogGrid from "../pages/Blog/BlogGrid/index";
import BlogDetails from "../pages/Blog/BlogDetails";

//Job
import JobList from "../pages/JobPages/JobList";
import JobGrid from "../pages/JobPages/JobGrid/index";
import JobDetails from "../pages/JobPages/JobDetails";
import JobCategories from "../pages/JobPages/JobCategories";
import CandidateList from "../pages/JobPages/CandidateList";
import CandidateOverview from "../pages/JobPages/CandidateOverview";
import ApplyJobs from "../pages/JobPages/ApplyJobs/index";

//Crypto
import CryptoWallet from "../pages/Crypto/CryptoWallet/crypto-wallet";
import CryptoBuySell from "../pages/Crypto/crypto-buy-sell";
import CryptoExchange from "../pages/Crypto/crypto-exchange";
import CryptoLending from "../pages/Crypto/crypto-lending";
import CryptoKYCApplication from "../pages/Crypto/crypto-kyc-application";
import CryptoOrders from "../pages/Crypto/CryptoOrders/crypto-orders";
import CryptoIcoLanding from "../pages/Crypto/CryptoIcoLanding/index";

//Authentication pages
import Login1 from "../pages/AuthenticationInner/Login";
import Register from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiModal from "../pages/Ui/UiModal";
import UiOffCanvas from "../pages/Ui/UiOffCanvas";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiPlaceholders from "../pages/Ui/UiPlaceholders";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiToasts from "../pages/Ui/UiToast";
import UiVideo from "../pages/Ui/UiVideo";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiColors from "../pages/Ui/UiColors";
import UiUtilities from "../pages/Ui/UiUtilities";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiRating from "../pages/Ui/UiRating";
import UiNotifications from "../pages/Ui/UiNotifications";

// Forms
import FormElements from "../pages/Forms/FormElements";
import FormLayouts from "../pages/Forms/FormLayouts";
import FormEditors from "../pages/Forms/FormEditors";
import FormUpload from "../pages/Forms/FormUpload";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormWizard from "../pages/Forms/FormWizard";
import FormMask from "../pages/Forms/FormMask";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormXeditable from "../pages/Forms/FormXeditable";

//Tables
import BasicTables from "../pages/Tables/BasicTables";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ReCharts from "../pages/Charts/ReCharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";

//Icons
import IconBoxicons from "../pages/Crypto/Icons/IconBoxicons";
import IconDripicons from "../pages/Crypto/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Crypto/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/Crypto/Icons/IconFontawesome";

// Maps
import MapsVector from "../pages/Maps/MapsVector";
import MapsLeaflet from "../pages/Maps/MapsLeaflet";
import MapsGoogle from "../pages/Maps/MapGoogle";
import DataTable from "../pages/Tables/DataTable";

// Auth
// import UserProfile from "../pages/Authentication/user-profile";
// import ForgotPassword from "../pages/Authentication/ForgotPassword";
import SignUp1 from "../pages/Authentication/Register";
import FormValidations from "../pages/Forms/FormValidations";

// hms - routes
import {
  Login,
  Dashboard,
  Category,
  Branches,
  Suppliers,
  Product,
  Customer,
  POS,
  Orders,
  WeighBill,
  Settings,
  SignUp,
  Expenses,
  Account,
  ForgotPassword,
  ChangePassword,
} from "views";
import AddNewProduct from "views/Product/AddNewProduct";
import EditProduct from "views/Product/EditProduct";
import ProductDetail from "views/Product/ProductDetails";
import { TLayoutType } from "types/layout";
import POSCheckout from "views/Checkout";
import { AppRoutes } from "../constants";
import AddProductTransfer from "views/ProductTransfer/AddProductTransfer";
import ProductTransfers from "views/ProductTransfer";
import EditProductTransfer from "views/ProductTransfer/EditProductTransfer";
import AddWeighBill from "views/WeighBill/AddWeighBill";
import EditWeighBill from "views/WeighBill/EditWeighBill";
import WeighBillDetails from "views/WeighBill/WeighBillDetails";
import AddExpense from "views/Expenses/AddExpense";
import EditExpense from "views/Expenses/EditExpense";
import AddSupplier from "views/Supplier/AddSupplier";
import EditSupplier from "views/Supplier/EditSupplier";
import AddAccount from "views/Account/AddAccount";
import EditAccount from "views/Account/EditAccount";
import AccountDetails from "views/Account/AccountDetails";
import BranchAnalytics from "views/Branch/BranchAnalytics";
import ProductTransferDetails from "views/ProductTransfer/ProductTransferDetails";
import SupplierDetail from "views/Supplier/SupplierDetail";
import { Navigate } from "react-router-dom";

type route = {
  path: string;
  component: JSX.Element;
  auth?: boolean | undefined | null;
  noAuth?: boolean | undefined | null;
  layoutType?: TLayoutType;
  permission?: string;
  feature?: string;
};

export const routes: route[] = [
  // auth
  { path: "/login", component: <Login />, noAuth: true },
  { path: "/forgot-password", component: <ForgotPassword />, noAuth: true },
  { path: "/change-password", component: <ChangePassword />, noAuth: true },
  { path: "/register", component: <SignUp />, noAuth: true },
  { path: "/register1", component: <SignUp1 />, noAuth: true },

  {
    path: "/pages-maintenance",
    component: <PagesMaintenance />,
    noAuth: true,
  },
  { path: "/pages-comingsoon", component: <PagesComingsoon />, noAuth: true },
  { path: "/404", component: <Pages404 />, noAuth: true },
  { path: "/pages-500", component: <Pages500 />, noAuth: true },
  {
    path: "/crypto-ico-landing",
    component: <CryptoIcoLanding />,
    noAuth: true,
  },

  // // Authentication Inner
  { path: "/pages-login", component: <Login1 />, noAuth: true },
  { path: "/pages-register", component: <Register />, noAuth: true },
  { path: "/pages-register-2", component: <Register2 />, noAuth: true },
  { path: "/page-recoverpw", component: <Recoverpw />, noAuth: true },
  { path: "/page-recoverpw-2", component: <Recoverpw2 />, noAuth: true },
  { path: "/auth-lock-screen", component: <LockScreen />, noAuth: true },
  { path: "/auth-lock-screen-2", component: <LockScreen2 />, noAuth: true },
  { path: "/page-confirm-mail", component: <ConfirmMail />, noAuth: true },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 />, noAuth: true },
  {
    path: "/auth-email-verification",
    component: <EmailVerification />,
    noAuth: true,
  },
  {
    path: "/auth-email-verification-2",
    component: <EmailVerification2 />,
    noAuth: true,
  },
  {
    path: "/auth-two-step-verification",
    component: <TwostepVerification />,
    noAuth: true,
  },
  {
    path: "/auth-two-step-verification-2",
    component: <TwostepVerification2 />,
    noAuth: true,
  },

  // Dashboards
  { path: "/", component: <Dashboard />, auth: true, feature: "dashboard" },

  // Categories
  {
    path: AppRoutes.CATEGORIES,
    component: <Category />,
    auth: true,
    permission: "read",
    feature: "categories",
  },

  // Branches
  {
    path: AppRoutes.BRANCHES,
    component: <Branches />,
    auth: true,
    permission: "read",
    feature: "branches",
  },
  {
    path: AppRoutes.BRANCH_ANALYTICS,
    component: <BranchAnalytics />,
    auth: true,
    permission: "read",
    feature: "branches",
  },

  // Suppliers
  {
    path: AppRoutes.SUPPLIERS,
    component: <Suppliers />,
    auth: true,
    permission: "read",
    feature: "suppliers",
  },
  {
    path: AppRoutes.SUPPLIER_DETAIL,
    component: <SupplierDetail />,
    auth: true,
    permission: "read_by_id",
    feature: "suppliers",
  },
  {
    path: AppRoutes.CREATE_SUPPLIER,
    component: <AddSupplier />,
    auth: true,
    permission: "create",
    feature: "suppliers",
  },
  {
    path: AppRoutes.EDIT_SUPPLIER,
    component: <EditSupplier />,
    auth: true,
    permission: "update",
    feature: "suppliers",
  },

  // Products
  {
    path: AppRoutes.PRODUCTS,
    component: <Product />,
    auth: true,
    permission: "read",
    feature: "products",
  },

  {
    path: "/view-product/:id",
    component: <ProductDetail />,
    auth: true,
    permission: "read",
    feature: "products",
  },

  {
    path: "/new-product",
    component: <AddNewProduct />,
    auth: true,
    permission: "create",
    feature: "products",
  },
  {
    path: "/edit-product/:id",
    component: <EditProduct />,
    auth: true,
    permission: "update",
    feature: "products",
  },

  // customers
  {
    path: AppRoutes.CUSTOMERS,
    component: <Customer />,
    auth: true,
    permission: "read",
    feature: "customers",
  },

  // orders
  {
    path: AppRoutes.ORDERS,
    component: <Orders />,
    auth: true,
    permission: "read",
    feature: "orders",
  },

  // POS
  {
    path: "/pos",
    component: <POS />,
    auth: true,
    layoutType: "horizontal",
    permission: "create",
    feature: "orders",
  },

  // checkout
  {
    path: "/checkout",
    component: <POSCheckout />,
    auth: true,
    layoutType: "horizontal",
    permission: "create",
    feature: "orders",
  },

  // File Manager
  { path: "/apps-filemanager", component: <FileManager />, auth: true },

  // product transfer
  {
    path: AppRoutes.ADD_PRODUCT_TRANSFER,
    component: <AddProductTransfer />,
    auth: true,
    permission: "create",
    feature: "transfers",
  },

  {
    path: AppRoutes.PRODUCT_TRANSFERS,
    component: <ProductTransfers />,
    auth: true,

    permission: "read",
    feature: "transfers",
  },
  {
    path: AppRoutes.EDIT_PRODUCT_TRANSFER,
    component: <EditProductTransfer />,
    auth: true,
    permission: "update",
    feature: "transfers",
  },
  {
    path: AppRoutes.VIEW_PRODUCT_TRANSFER,
    component: <ProductTransferDetails />,
    auth: true,
    permission: "read_by_id",
    feature: "transfers",
  },

  // weigh bill
  {
    path: AppRoutes.WEIGHBILLS,
    component: <WeighBill />,
    auth: true,
    permission: "read",
    feature: "weighbills",
  },
  {
    path: AppRoutes.CREATE_WEIGHBILL,
    component: <AddWeighBill />,
    auth: true,
    permission: "create",
    feature: "weighbills",
  },
  {
    path: AppRoutes.EDIT_WEIGHBILL,
    component: <EditWeighBill />,
    auth: true,
    permission: "update",
    feature: "weighbills",
  },
  {
    path: AppRoutes.VIEW_WEIGHBILL,
    component: <WeighBillDetails />,
    auth: true,
    permission: "read_by_id",
    feature: "weighbills",
  },

  // Settings
  {
    path: "/settings",
    component: <Settings />,
    auth: true,
    layoutType: "horizontal",
    permission: "read",
    feature: "settings",
  },

  // Expenses
  {
    path: AppRoutes.EXPENSES,
    component: <Expenses />,
    auth: true,
    permission: "read",
    feature: "expenses",
  },
  {
    path: AppRoutes.CREATE_EXPENSE,
    component: <AddExpense />,
    auth: true,
    permission: "create",
    feature: "expenses",
  },
  {
    path: AppRoutes.EDIT_EXPENSE,
    component: <EditExpense />,
    auth: true,
    permission: "update",
    feature: "expenses",
  },

  // Accounts
  {
    path: AppRoutes.ACCOUNTS,
    component: <Account />,
    auth: true,
    permission: "read",
    feature: "accounts",
  },
  {
    path: AppRoutes.ADD_ACCOUNT,
    component: <AddAccount />,
    auth: true,
    permission: "create",
    feature: "accounts",
  },
  {
    path: AppRoutes.EDIT_ACCOUNT,
    component: <EditAccount />,
    auth: true,
    permission: "update",
    feature: "accounts",
  },
  {
    path: AppRoutes.VIEW_ACCOUNT,
    component: <AccountDetails />,
    auth: true,
    permission: "read_by_id",
    feature: "accounts",
  },

  // Chat
  { path: "/chat", component: <Chat />, auth: true },

  // Calendar
  { path: "/calendar", component: <Calendar />, auth: true },

  // Ecommerce
  {
    path: "/ecommerce-product-detail/:id?",
    component: <EcommerceProductDetail />,
    auth: true,
  },
  {
    path: "/ecommerce-products",
    component: <EcommerenceProducts />,
    auth: true,
  },
  // {
  //   path: "/add-product",
  //   component: <EcommerceAddProduct />,
  //   auth: true,
  // },
  { path: "/ecommerce-cart", component: <EcommerceCart />, auth: true },
  {
    path: "/ecommerce-checkout",
    component: <EcommerceCheckout />,
    auth: true,
  },
  { path: "/ecommerce-orders", component: <EcommerceOrders />, auth: true },
  {
    path: "/ecommerce-customers",
    component: <EcommerceCustomers />,
    auth: true,
  },
  { path: "/ecommerce-shops", component: <EcommerceShops />, auth: true },

  // Blog
  { path: "/blog-list", component: <BlogList />, auth: true },
  { path: "/blog-grid", component: <BlogGrid />, auth: true },
  { path: "/blog-details", component: <BlogDetails />, auth: true },

  // Crypto
  { path: "/crypto-wallet", component: <CryptoWallet />, auth: true },
  { path: "/crypto-buy-sell", component: <CryptoBuySell />, auth: true },
  { path: "/crypto-exchange", component: <CryptoExchange />, auth: true },
  { path: "/crypto-lending", component: <CryptoLending />, auth: true },
  { path: "/crypto-orders", component: <CryptoOrders />, auth: true },
  {
    path: "/crypto-kyc-application",
    component: <CryptoKYCApplication />,
    auth: true,
  },

  // Tasks
  { path: "/tasks-list", component: <TasksList />, auth: true },
  { path: "/tasks-kanban", component: <TasksKanban />, auth: true },
  { path: "/tasks-create", component: <TasksCreate />, auth: true },

  // Invoices
  { path: "/invoices-list", component: <InvoicesList />, auth: true },
  { path: "/invoices-detail/:id?", component: <InvoiceDetail />, auth: true },

  // Projects
  { path: "/projects-grid", component: <ProjectsGrid />, auth: true },
  { path: "/projects-list", component: <ProjectsList />, auth: true },
  { path: "/projects-create", component: <ProjectsCreate />, auth: true },
  { path: "/projects-overview", component: <ProjectsOverview />, auth: true },
  {
    path: "/projects-overview/:id?",
    component: <ProjectsOverview />,
    auth: true,
  },

  // Email
  { path: "/email-inbox", component: <EmailInbox />, auth: true },
  { path: "/email-read/:id?", component: <EmailRead />, auth: true },
  {
    path: "/email-template-basic",
    component: <EmailBasicTemplate />,
    auth: true,
  },
  {
    path: "/email-template-alert",
    component: <EmailAlertTemplate />,
    auth: true,
  },
  {
    path: "/email-template-billing",
    component: <EmailTemplateBilling />,
    auth: true,
  },

  // Contacts
  { path: "/contacts-profile", component: <ContactsProfile />, auth: true },
  { path: "/contacts-grid", component: <ContactsGrid />, auth: true },
  { path: "/contacts-list", component: <ContactsList />, auth: true },

  // Job
  { path: "/job-list", component: <JobList />, auth: true },
  { path: "/job-apply", component: <ApplyJobs />, auth: true },
  { path: "/job-grid", component: <JobGrid />, auth: true },
  { path: "/job-details", component: <JobDetails />, auth: true },
  { path: "/job-categories", component: <JobCategories />, auth: true },
  { path: "/candidate-list", component: <CandidateList />, auth: true },
  {
    path: "/candidate-overview",
    component: <CandidateOverview />,
    auth: true,
  },

  // Utility
  { path: "/pages-starter", component: <PagesStarter />, auth: true },
  { path: "/pages-timeline", component: <PagesTimeline />, auth: true },
  { path: "/pages-faqs", component: <PagesFaqs />, auth: true },
  { path: "/pages-pricing", component: <PagesPricing />, auth: true },

  // UI
  { path: "/ui-alerts", component: <UiAlert />, auth: true },
  { path: "/ui-buttons", component: <UiButtons />, auth: true },
  { path: "/ui-cards", component: <UiCards />, auth: true },
  { path: "/ui-dropdowns", component: <UiDropdown />, auth: true },
  { path: "/ui-grid", component: <UiGrid />, auth: true },
  { path: "/ui-images", component: <UiImages />, auth: true },
  { path: "/ui-modals", component: <UiModal />, auth: true },
  { path: "/ui-offcanvas", component: <UiOffCanvas />, auth: true },
  { path: "/ui-rangeslider", component: <UiRangeSlider />, auth: true },
  { path: "/ui-progressbars", component: <UiProgressbar />, auth: true },
  { path: "/ui-placeholders", component: <UiPlaceholders />, auth: true },
  {
    path: "/ui-tabs-accordions",
    component: <UiTabsAccordions />,
    auth: true,
  },
  { path: "/ui-typography", component: <UiTypography />, auth: true },
  { path: "/ui-toasts", component: <UiToasts />, auth: true },
  { path: "/ui-video", component: <UiVideo />, auth: true },
  { path: "/ui-general", component: <UiGeneral />, auth: true },
  { path: "/ui-colors", component: <UiColors />, auth: true },
  { path: "/ui-utilities", component: <UiUtilities />, auth: true },
  { path: "/ui-carousel", component: <UiCarousel />, auth: true },
  { path: "/ui-lightbox", component: <UiLightbox />, auth: true },
  { path: "/ui-rating", component: <UiRating />, auth: true },
  { path: "/ui-notifications", component: <UiNotifications />, auth: true },

  // Forms
  { path: "/form-elements", component: <FormElements />, auth: true },
  { path: "/form-layouts", component: <FormLayouts />, auth: true },
  { path: "/form-uploads", component: <FormUpload />, auth: true },
  { path: "/form-repeater", component: <FormRepeater />, auth: true },
  { path: "/form-wizard", component: <FormWizard />, auth: true },
  { path: "/form-mask", component: <FormMask />, auth: true },
  { path: "/form-advanced", component: <FormAdvanced />, auth: true },
  { path: "/form-editors", component: <FormEditors />, auth: true },
  { path: "/form-xeditable", component: <FormXeditable />, auth: true },
  { path: "/form-validation", component: <FormValidations />, auth: true },

  // Tables
  { path: "/tables-basic", component: <BasicTables />, auth: true },
  { path: "/tables-datatable", component: <DataTable />, auth: true },

  // Charts
  { path: "/apex-charts", component: <ChartApex />, auth: true },
  { path: "/e-charts", component: <EChart />, auth: true },
  { path: "/sparkline-charts", component: <SparklineChart />, auth: true },
  { path: "/re-charts", component: <ReCharts />, auth: true },
  { path: "/chartjs-charts", component: <ChartjsChart />, auth: true },

  // Icons
  { path: "/icons-boxicons", component: <IconBoxicons />, auth: true },
  { path: "/icons-dripicons", component: <IconDripicons />, auth: true },
  {
    path: "/icons-materialdesign",
    component: <IconMaterialdesign />,
    auth: true,
  },
  { path: "/icons-fontawesome", component: <IconFontawesome />, auth: true },

  // Maps
  { path: "/maps-google", component: <MapsGoogle />, auth: true },
  { path: "/maps-vector", component: <MapsVector />, auth: true },
  { path: "/maps-leaflet", component: <MapsLeaflet />, auth: true },

  { path: "*", component: <Navigate to="/404" /> },
];
